module.exports = __webpack_public_path__ + "img/arrowProductDetail.fefbbd12.svg";